import { IDeviceInput } from '../../schemas/App/App.Schema';

export class DeviceRegister {
  private readonly deviceRegisterState: IDeviceInput = {
    uuId: '',
    upn: '',
    carrierId: '',
    deviceToken: '',
    email: '',
    phone: ''
  };

  get uuid() {
    return this.deviceRegisterState.uuId;
  }
  set uuid(value) {
    this.deviceRegisterState.uuId = value;
  }

  get upn() {
    return this.deviceRegisterState.upn;
  }
  set upn(value) {
    this.deviceRegisterState.upn = value;
  }

  get carrierId() {
    return this.deviceRegisterState.carrierId;
  }
  set carrierId(value) {
    this.deviceRegisterState.carrierId = value;
  }
  get deviceToken() {
    return this.deviceRegisterState.deviceToken;
  }
  set deviceToken(value) {
    this.deviceRegisterState.deviceToken = value;
  }
  get email() {
    return this.deviceRegisterState.email;
  }
  set email(value) {
    this.deviceRegisterState.email = value;
  }

  get phone() {
    return this.deviceRegisterState.phone;
  }
  set phone(value) {
    this.deviceRegisterState.phone = value;
  }

  get deviceOs() {
    return this.deviceRegisterState.deviceOs;
  }
  set deviceOs(value) {
    this.deviceRegisterState.deviceOs = value;
  }
  get deviceOsVersion() {
    return this.deviceRegisterState.deviceOsVersion;
  }
  set deviceOsVersion(value) {
    this.deviceRegisterState.deviceOsVersion = value;
  }

  getRequestPayload() {
    return {
      mutation: {
        registerDevice: {
          __args: {
            input: this.deviceRegisterState
          }
        }
      }
    };
  }
}
